import { render, staticRenderFns } from "./CreateMagazineRecipient.vue?vue&type=template&id=66a0f2f8&"
import script from "./CreateMagazineRecipient.vue?vue&type=script&lang=js&"
export * from "./CreateMagazineRecipient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports